import React from 'react';
import { sidebarContainer, sidebarItems } from 'theme/motion.variants';
import { useLocation } from 'react-router-dom';

import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  MotionItems,
  SidebarLink,
  SidebarButton
} from './sidebar.styles';
import { CallToActionRoute } from 'components/common/CallToActionRoute';
import { dynamicLinks } from '../navbar/navbar.data';

const Sidebar = ({ isOpen, toggle }) => {
  const { pathname } = useLocation();

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu
          variants={sidebarContainer}
          animate={isOpen ? 'open' : 'closed'}
          style={{ animationDelay: '1s' }}
        >
          {dynamicLinks.map((item) => (
            <MotionItems key={item.id} variants={sidebarItems}>
              <SidebarLink to={item.path} onClick={toggle}>
                {item.url}
              </SidebarLink>
            </MotionItems>
          ))}
        </SidebarMenu>
        {pathname === '/' ? (
          <SidebarButton>
            <CallToActionRoute to="/signin">
              Sign In<span className="btn-cta--gradient"></span>
            </CallToActionRoute>
          </SidebarButton>
        ) : (
          <SidebarButton>
            <CallToActionRoute to="/">
              Home<span className="btn-cta--gradient"></span>
            </CallToActionRoute>
          </SidebarButton>
        )}
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
